import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
    mandateId = 0;
    amountInEur = 0;
}
